import ComponentOpenAI from '../interfaces/ComponentOpenAI';

const OPERATIONAL = 'operational';
const CHAT_COMPONENT = 'Chat';

class OpenAIService {
  public static isOpenAIDown(): Promise<boolean> {
    return fetch(`${process.env.REACT_APP_OPENAI_API_STATUS}`)
      .then(response => response.json())
      .then((response) => {
        const chatComponent = response.components.find(
          (component: ComponentOpenAI) => CHAT_COMPONENT === component.name
        );

        return (chatComponent && OPERATIONAL !== chatComponent.status);
      })
      .catch(error => {
        console.error('Error fetching OpenAI status:', error);

        return true;
      });
  }
}

export default OpenAIService;
